import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-papsuccessmessage',
  templateUrl: './papsuccessmessage.component.html',
  styleUrls: ['./papsuccessmessage.component.scss']
})
export class PapsuccessmessageComponent implements OnInit {

  @Input() eventid: number;
  @Output() registerventid = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }

  clickhere() {
      this.registerventid.emit(this.eventid);
  }

}
